import { Box } from '@material-ui/core';
import React from 'react';
import { useFormContext } from 'react-hook-form';

import { Font } from '@/components/shared/components/Font';
import { NemuruDialog } from '@/components/shared/components/NemuruDialog';
import { useAddressContext } from '@/components/shared/components/NewContextForms/components/AutocompleteAddressHeadless/contexts/AddressContext';
import { useAddressFormFields } from '@/components/shared/components/NewContextForms/components/AutocompleteAddressHeadless/hooks/useAddressFormFields';
import { AddressMode } from '@/components/shared/components/NewContextForms/components/AutocompleteAddressHeadless/types/AddressMode';
import { StandardButton } from '@/components/shared/components/StandardButton';
import { Text } from '@/components/shared/components/Text';

interface AddressDialogProps {
  children: React.ReactNode;
  onSaveForm?: () => void;
  titleTextId?: string;
  subtitleTextId?: string;
}

export const AddressDialog = ({ children, titleTextId, subtitleTextId, onSaveForm }: AddressDialogProps) => {
  const { formState } = useFormContext();
  const { openedDialog, setOpenedDialog, mode } = useAddressContext();
  const { restoreTemporaryDialogData, getValidation, areFieldsValid, dialogHasChanges, updateFormattedAddressField } =
    useAddressFormFields();

  return (
    <NemuruDialog
      titleTextElement={<Text tId={titleTextId ?? 'ADDRESS'} />}
      opened={openedDialog}
      setOpened={() => {
        // this function is only used when clicking the "close" button
        if (openedDialog) {
          setOpenedDialog(false);
          restoreTemporaryDialogData();
        }
      }}
      dialogProps={{ maxWidth: 'sm' }}
      buttons={
        <StandardButton
          disabled={!(mode === AddressMode.CONFIRM && areFieldsValid && (dialogHasChanges || formState.isDirty))}
          variant="contained"
          onClick={async () => {
            updateFormattedAddressField();
            const areFieldsValid = await getValidation();
            if (areFieldsValid) {
              if (onSaveForm) {
                onSaveForm();
              }
              setOpenedDialog(false);
            }
          }}
        >
          <Text tId={'SAVE'} />
        </StandardButton>
      }
    >
      <>
        {subtitleTextId && (
          <Box mb={2}>
            <Font variant="h5">
              <Text tId={subtitleTextId} />
            </Font>
          </Box>
        )}
        {children}
      </>
    </NemuruDialog>
  );
};
